export async function fetchImageAsFile(url) {
  const response = await fetch(url);
  if (!response.ok) throw new Error('Failed to fetch image');
  const blob = await response.blob();
  const contentType = blob.type || 'image/jpeg';
  const ext = contentType.split('/')[1] || 'jpg';
  let baseName = url.split('/').pop()?.split('?')[0] || '';
  if (!baseName || !baseName.includes('.')) {
    baseName = `image.${ext}`;
  }
  return new File([blob], baseName, { type: contentType });
}